module.exports = __webpack_public_path__ + "Worker.8885f282a2ef26034fc69264db1b46c6.hashedasset.svg";